module.exports = "/images/email-verify.png?8560c14de0758986d29c9e2d032d99c0";